<template>
  <!--  <b-container class="p-2" style="max-width: 400px; width: calc(100vw - 10px);">-->
  <b-container class="p-2" style="max-width: 400px; width: calc(100vw - 50px);">
    <b-row v-if="multiSelect">
      <b-col class="text-center font-weight-bold" style="background-color: OrangeRed">{{$tr('grit-edit.bulk', 'Bulk edit')}}</b-col>
    </b-row>
    <b-row class="pt-2 pb-0">
      <b-col ref="inputNest" tabindex="0" @keydown="onKeyDown">
      </b-col>
    </b-row>
    <b-row class="align-items-right p-0 m-0">
      <b-col></b-col>
      <FooterButton
          class="col-auto p-0 pr-1"
          type="Cancel"
          @cancel="close"
          :read-only="false"
          :disabled="validatedField != null ? validatedField.validationInProgress : false"
          :show-label="false"
      >
      </FooterButton>
      <FooterButton
          class="col-auto p-0 pr-2"
          type="Save"
          :focus-aware="false"
          :showLabel="false"
          :label="SAVE_LABEL"
          @save="saveAndClose"
          :disabled="validatedField != null ? (validatedField.validationInProgress || !this.validatedField.isValid) : false"
      ></FooterButton>
      <b-col></b-col>
    </b-row>
  </b-container>
</template>

<script>

import {getComponentClass} from "@/components/forms/renderers/Renderers";
import FormModel from "@/components/forms/FormModel";
import PermissionsSet from "@/server/PermissionsSet";
import CloseButton from "@/components/navbar/CloseButton";
import FooterButton from "@/components/navbar/FooterButton";
import RpcInputValidationException from "@/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException";
import {cloneClassInstance, cloneEntity} from "@/utils/Objects";
import yaml from "js-yaml";
import Rpc from "@/Rpc";
import EventBus from "@/utils/EventBus";

export default {
  name: "GridCellEditor",
  components: {FooterButton, CloseButton},

  async mounted() {
    // this.$onEvent('Decimal', (val) => {
    //   console.log(val)
    //   this.disableSave = !val;
    //   this.focusAwareState = val;
    // })
    this.fieldConfig = this.columnConfig.fieldConfig;
    this.formConfig = this.columnConfig.formConfig;

    if ((this.rowData?.length > 1 && this.rowData[0] !== undefined) || (this.streaming && this.multiSelect)) {
      // rowData jest obiektem jeśli jest 1 lub array jeśli jest więcej
      await this.mountMultiEdit();
    } else {
      // console.log("Original val: {}", this.validatedField.value);
      this.mountSingleEdit();
      if (this.fieldConfig.autoValidateOnFormLoading) {
        await this.forceValidateOnLoad();
      }
    }
  },
  beforeDestroy() {
    //EventBus.$off("Decimal");
    if(this.input) {
      let input = this.input;
      input.beforeUnmount?.();
      input.$destroy?.();
      const index = this.$children.indexOf(input);
      if (index > -1) {
        this.$children.splice(index, 1);
      }
      setTimeout(() => {
        try {
          input?.afterUnmount?.();
        } finally {
          setTimeout(() => {
            input.onDestroy?.();
          });
        }
      });
      this.input = null;
    }
  },
  methods: {
    commit() {
      if (this.columnConfig.dynamicColumn) {
        this.$emit("commit", this.form.fields[this.fieldConfig.fieldName]._value);
      }
    },

    async forceValidateOnLoad() {
      let entity = this.rowData;
      let clazz = entity.__typename__;
      let id = entity.id;
      let fieldName = this.fieldConfig.fieldName;
      let value = entity[fieldName];
      let result = await Rpc.Forms.validateField(clazz, fieldName, value, id);
      this.validatedField.errorMessage = result.errorMessage;
      this.validatedField.isValid = result.isValid;
    },

    mountSingleEdit() {
      this.setupForm();

      let fieldConfig = cloneClassInstance(this.fieldConfig);
      fieldConfig.autofocus = true;

      const clazz = getComponentClass(fieldConfig.renderer, this.$router);

      this.validatedField = this.form.validatedFieldsByName.get(fieldConfig.fieldName);
      this.validatedField.masterFormModel = this.form;
      this.form.editMode(this.rowData, 'EDIT');

      const input = new clazz({
        propsData: {
          fieldConfig,
          validatedField: this.validatedField,
          mode: this.mode,
          parentForm: this.form,
          masterFormModel: this.form,
          customFocusOnHide: this.customFocusOnHide,
          openFromGrid: true,
          gridEditor: this
        }
      });

      this.$children.push(input);
      input.$parent = this;
      input.$root = this.$root;
      input.$mount();

      this.$refs.inputNest.appendChild(input.$el);

      input.setEditorMode?.(false);
      input.setReadOnly?.(false);
      this.input = input;

      this.$nextTick(() => {
        if (this.input && this.input.$el && typeof this.input.$el.querySelector === 'function') {
          const focusableElement = this.input.$el.querySelector('input, textarea');
          if (focusableElement) {
            focusableElement.focus();
            if (focusableElement.select) {
              focusableElement.select();
            }
          }
        } else {
          console.warn('Brak elementu do ustawienia fokusu.');
        }
      });
    },

    async mountMultiEdit() {
      this.setupForm();

      let fieldConfig = this.fieldConfig;
      fieldConfig.autofocus = true;

      const clazz = getComponentClass(fieldConfig.renderer, this.$router);

      this.validatedField = this.form.validatedFieldsByName.get(fieldConfig.fieldName);
      this.validatedField.masterFormModel = this.form;
      this.multiSelect = true;
      let clone = cloneEntity(this.rowData[0]); //TODO sprawdzic czy są tutaj trans
      this.form.createMode(clone);
      this.form.fakeModel = this.multiSelect;
      this.form.fillValuesFrom(clone);
      if (fieldConfig.defaultValue !== null) {
        this.validatedField.value = yaml.load(fieldConfig.defaultValue);
      } else {
        this.validatedField.value = null;
      }

      const input = new clazz({
        propsData: {
          fieldConfig,
          validatedField: this.validatedField,
          mode: this.mode,
          parentForm: this.form,
          masterFormModel: this.form,
          customFocusOnHide: this.customFocusOnHide,
          openFromGrid: true,
          openFromMultiSelectGrid: true,
          selectedRows: this.rowData
        }
      });

      this.$children.push(input);
      input.$parent = this;
      input.$root = this.$root;
      input.$mount();

      this.$refs.inputNest.appendChild(input.$el);

      input.setEditorMode(false);
      input.setReadOnly(false);

      if (!(this.streaming && this.rowData.length > 1)) {
        for (let item of this.rowData) {
          if (this.formConfig.isView) {
            let rootClassShortId = this.formConfig.rootClassShortId;
            if (rootClassShortId) {
              this.listOfIds.push(item[rootClassShortId]);
            }
          } else {
            this.listOfIds.push(item.id);
          }
        }
      }

      this.changeFieldBulkEdit = input;
      this.input = input;
    },

    setupForm() {
      this.form = this.constructForm();
    },

    constructForm() {
      let result = new FormModel(this.formConfig);
      result.restrictedWrite = this.formConfig.restrictedWrite;
      result.permissions = this.permissions;
      result.effectivePermissionWrite = this.formConfig.effectivePermissionWrite;
      result.effectivePermissionRead = this.formConfig.effectivePermissionRead;
      result.restrictedWrite = this.formConfig.restrictedWrite;
      result.restrictedRead = this.formConfig.restrictedRead;

      result.detailsConfig = this.detailsConfig;
      result.extensionConfig = this.extensionConfig;
      return result;
    },

    onKeyDown(event) {
      if (event.key === "Enter") {
        this.saveAndClose().then()
      }
    },

    async saveAndClose() {
      await  this.form.fields[this.fieldConfig.fieldName].validate();
      if(!this.form.fields[this.fieldConfig.fieldName].isValid){
        DialogManager.info($tr('multiedit.not-valid.title', "Value is not valid"), this.form.fields[this.fieldConfig.fieldName].hintMessage).then();
        this.close();
        return;
      }
      if ((this.form && this.form.fields[this.fieldConfig.fieldName].isValid) || this.form.formConfig.isView) {
        if (await this.save()) {
          this.close();
        }
      }
      this.$emit("save");
    },

    async saveStreamedMultiSelect() {
      if (this.form.formConfig.isView) {
        let fieldNameFromView = this.fieldConfig.fieldName;
        let fieldNameFromMaster = fieldNameFromView.slice(fieldNameFromView.lastIndexOf("_") + 1);
        this.result = await Rpc.FormsStreams.editEntitiesFromStream(
            this.streamingEngine.getStreamSelection(),
            fieldNameFromMaster,
            this.changeFieldBulkEdit.validatedField.value,
            this.form.formConfig.masterClass).lock();
      } else {
        this.result = await Rpc.FormsStreams.editEntitiesFromStream(
            this.streamingEngine.getStreamSelection(),
            this.fieldConfig.fieldName,
            this.changeFieldBulkEdit.validatedField.value,
            this.form.formConfig.formClassLong).lock();
      }
      // todo proc results;
      return true;
    },
    async save() {
      if (this.multiSelect) {
        if(this.streaming) {
          return this.saveStreamedMultiSelect();
        }

        try {
          if (this.form.formConfig.isView) {
            let fieldNameFromView = this.fieldConfig.fieldName;
            let fieldNameFromMaster = fieldNameFromView.slice(fieldNameFromView.lastIndexOf("_") + 1);
            this.result = await Rpc.Forms.editEntities(this.listOfIds, fieldNameFromMaster, this.changeFieldBulkEdit.validatedField.value,
                this.form.formConfig.masterClass).lock();
          } else {
            this.result = await Rpc.Forms.editEntities(this.listOfIds, this.fieldConfig.fieldName, this.changeFieldBulkEdit.validatedField.value,
                this.form.formConfig.formClassLong).lock();
          }
          EventBus.$emit(Events.listMultiEdit, this.listOfIds);
          return true;
        } catch (e) {
          if (e instanceof RpcInputValidationException) {
            console.log(e);
            let errorSummary = "";
            if(e.errorMessage?.length){
              errorSummary = e.errorMessage;
            }
            else{
              for (let fieldName in e.fields) {
                let field = e.fields[fieldName];
                if (field['errorMessage']) {
                  errorSummary += field['errorMessage'] + "\n";
                }
              }
            }
            await DialogManager.infoHtml($tr("recordCantBeSaved","Record can't be saved"), errorSummary);
          }
          console.error(e);
          return false;
        }
      } else {
        try {
          if (this.form.formConfig.isView) {
            let rootClassShortId = this.formConfig.rootClassShortId;
            let masterClass = this.formConfig.masterClass;
            let masterId = this.form.originalSource[rootClassShortId];
            let masterInstance = await Rpc.Forms.getEntity(masterClass, masterId);
            let viewFieldName = this.fieldConfig.fieldName;
            let fieldNameFromMaster = viewFieldName.slice(viewFieldName.lastIndexOf("_") + 1);
            masterInstance[fieldNameFromMaster] = this.form.originalSource[viewFieldName];
            await masterInstance.save();
            this.entityInstance = masterInstance;
          } else {
            this.entityInstance = await this.form.saveEntity();
          }
          if ((!this.form.isValid || this.form.temporaryListsErrors) && !this.form.formConfig.isView) {
            setTimeout(() => {
              this.$emit("unsaved-changes");
            });
            DialogManager.infoHtml($tr('saveFailed','Save failed'),
                $tr("GridCellEditor.arent.save","Some records aren't save successfully, fix or delete broken records")).then();
            return false;
          }
          this.commit()
          return true;
        } catch (e) {
          if (e instanceof RpcInputValidationException) {
            let errorSummary = "";
            for (let fieldName in e.fields) {
              let field = e.fields[fieldName];
              if (field['errorMessage']) {
                errorSummary += field['errorMessage'] + "\n";
              }
            }
            if (e.errorMessage) {
              errorSummary += e.errorMessage;
            }
            await DialogManager.infoHtml($tr("record.cant.saved","Record can't be saved"), errorSummary);
            // this.rowData[this.fieldConfig.fieldName] = this.oldVal;
          }
          return false;
        }
      }
    },


    focus() {
    },

    close() {
      this.$emit("close");
    },
  },

  props: {
    /** @type {Object<x:number, y:number>} */
    cell: {default: null, type: Object},

    /** @type {ColumnDefinition} */
    columnConfig: {default: null},
    rowData: {default: null},

    /** @type {DataGrid2} */
    dataGrid: {default: null},
    gridVirtualArray: {default: null}, // type VirtualArray

    customFocusOnHide: {default: null},

    streaming: {default: false},
    streamingEngine: {default: null},
  },
  data: function () {
    return {
      SAVE_LABEL:$tr("Apply","Apply"),
      form: null,
      permissions: new PermissionsSet(),
      multiSelect: false,
      falseState: false,
      changeFieldBulkEdit: null,
      listOfIds: [],
      oldValues: [],
      disableSave: false,
      focusAwareState: true,
      validatedField: null
    }
  }

}
</script>

<style scoped>

</style>